import { call, put } from "redux-saga/effects";
import { push } from "connected-react-router";
import { actions as toastrAction } from "react-redux-toastr";
import api from "../../services/api";
import PontosActions from "../ducks/pontos";
import ErrorsActions from "../ducks/errors";

export function* getPontos({ id, page, filter }) {
  try {
    const paginate = page === undefined ? 1 : page;
    const filtro = filter === undefined ? "" : filter;
    const response = yield call(
      api.get,
      `pontos/${id}?page=${paginate}&filter=${filtro}`
    );
    if (response.data.hasProject !== undefined && !response.data.hasProject) {
      throw new Error({ code: 400, message: "Projéto inválido" });
    } else {
      yield put(PontosActions.setPontos(response.data));
    }
  } catch (err) {
    yield put(
      toastrAction.add({
        type: "error",
        title: "Ops...",
        message: "Não foi possível retornar os pontos, tente novamente",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
    yield put(push("/projetos"));
  }
}
export function* createPonto({ data }) {
  try {
    if (!data.IdCliente) {
      throw new Error("Cliente inválido");
    }
    const response = yield call(api.post, `pontos/${data.IdCliente}`, data);

    if (response.data.hasProject !== undefined && !response.data.hasProject) {
      throw new Error({ code: 400, message: "Projéto inválido" });
    } else {
      yield put(push(`/projetos/${data.IdCliente}/pontos`));
    }
  } catch (err) {
    if (err.response.data.message !== undefined) {
      yield put(ErrorsActions.setError(err.response.data.message));
      yield put(PontosActions.hideLoader());
    }
    yield put(
      toastrAction.add({
        type: "error",
        title: "Ocorreu um erro",
        message: "Verifique os dados inseridos e tente novamente",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
  }
}
export function* getPonto({ id, ponto }) {
  try {
    const response = yield call(api.get, `pontos/${id}/${ponto}`);
    if (response.data.hasProject !== undefined && !response.data.hasProject) {
      throw new Error({ code: 400, message: "Projéto inválido" });
    } else {
      if (!response.data) {
        throw new Error("Nenhum dado encontrado, tente novamente");
      }
      yield put(PontosActions.setPonto(response.data));
    }
  } catch (err) {
    yield put(
      toastrAction.add({
        type: "error",
        title: "Ops...",
        message: "Não foi possível carregar o ponto, tente novamente",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
    yield put(push(`/projetos/${id}/pontos`));
  }
}
export function* updatePonto({ data }) {
  try {
    yield call(api.put, `pontos/${data.IdCliente}/${data.IdPonto}`, data);
    yield put(push(`/projetos/${data.IdCliente}/pontos`));
  } catch (err) {
    if (err.response.data.message !== undefined) {
      yield put(ErrorsActions.setError(err.response.data.message));
      yield put(PontosActions.hideLoader());
    }
    yield put(
      toastrAction.add({
        type: "error",
        title: "Ops...",
        message: "Não foi possível editar o pontos, tente novamente",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
  }
}
export function* deletePonto({ id }) {
  try {
    const response = yield call(api.delete, `pontos/${id}`);
    yield put(PontosActions.deleteSucc(response.data));
    yield put(
      toastrAction.add({
        type: "success",
        title: "Tudo certo!",
        message: "Ponto removido com sucesso!",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
  } catch (err) {
    yield put(
      toastrAction.add({
        type: "error",
        title: "Ops...",
        message: "Não foi possível remover o ponto, tente novamente",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
  }
}
export function* getColetoresPontos({ id }) {
  try {
    const response = yield call(api.get, `list-coletor/${id}`);
    yield put(PontosActions.setColetoresPoints(response.data));
  } catch (err) {
    yield put(
      toastrAction.add({
        type: "error",
        title: "Ops...",
        message: "Não foi possível carregar os coletores, tente novamente",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
  }
}


export function* getConsumidoresPontos({ id }) {
  try {
    const response = yield call(api.get, `list-consumidor/${id}`);
    yield put(PontosActions.setConsumidoresPoints(response.data));
  } catch (err) {
    yield put(
      toastrAction.add({
        type: "error",
        title: "Ops...",
        message: "Não foi possível carregar os consumidores, tente novamente",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
  }
}

export function* getValores() {
  try {
    const response = yield call(api.get, `list-valores`);
    yield put(PontosActions.setValores(response.data));
  } catch (err) {
    yield put(
      toastrAction.add({
        type: "error",
        title: "Ops...",
        message: "Não foi possível carregar os tipo de valores, tente novamente",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
  }
}

export function* getUnidades() {
  try {
    const response = yield call(api.get, `list-unidades`);
    yield put(PontosActions.setUnidades(response.data));
  } catch (err) {
    yield put(
      toastrAction.add({
        type: "error",
        title: "Ops...",
        message: "Não foi possível carregar as unidades, tente novamente",
        closeOnToastrClick: true,
        position: "top-center",
        options: {
          showCloseButton: true,
          closeOnToastrClick: true,
          progressBar: true,
          transitionOut: "fadeOut"
        }
      })
    );
  }
}
